// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";

let jsonCodec = Jzon.object2(param => [
  param.owner,
  param.author
], param => ({
  TAG: "Ok",
  _0: {
    owner: param[0],
    author: param[1]
  }
}), Jzon.field("_extOwner", Document$LumiStore.Key.jsonCodec()), Jzon.field("_extAuthor", Document$LumiStore.Key.jsonCodec()));

export {
  jsonCodec,
}
/* jsonCodec Not a pure module */
